import { stdObject } from "../../../data/types/stdObject";
import { colors } from "../../../data/colors";
import { useDocContext } from "../../../context/MainContext";

export default function CommissionBar({ comm, line, style = {} }: stdObject) {
  const { staffList } = useDocContext();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        position: "absolute",
        top: 2,
        right: 0,
        height: 5,
        width: "100%",
        ...style,
      }}
    >
      {staffList
        .filter((e: stdObject) => e.ACTIA1)
        .map((e: stdObject, index: number) => {
          const validValue = comm.filter(
            (v: stdObject) =>
              e.CODIA1 === v.GRUCOY &&
              v.AGECOY !== "" &&
              line === v.LINCOY &&
              v.PRECOY,
          );
          return (
            <div
              key={index}
              style={{
                flex: 1,
                backgroundColor: validValue.length
                  ? validValue[0].PAGCOY > 0
                    ? colors.blue
                    : colors.green
                  : colors.grey,
              }}
            ></div>
          );
        })}
    </div>
  );
}
